module.exports = __webpack_public_path__ + "static/media/purpleEllipsesPageViewsBackground.beec41cc.svg";